import each from '../functions/each';
import { isUndefined } from '../utils';
function extend(target, object1, ...objectN) {
  objectN.unshift(object1);
  each(objectN, (_, object) => {
    each(object, (prop, value) => {
      if (!isUndefined(value)) {
        target[prop] = value;
      }
    });
  });
  return target;
}
export default extend;